import type { ReactNode } from "react"
import { cn } from "@/lib/utils"

export interface PageHeaderProps {
  title: ReactNode
  description?: ReactNode
  actionSlot?: ReactNode
  className?: string
}

export function PageHeader({
  title,
  description,
  actionSlot,
  className,
}: PageHeaderProps) {
  const body = (
    <div className="min-w-0 flex flex-col">
      <h1 className="text-page-title text-foreground">{title}</h1>
      {description && (
        <p className="text-caption text-muted-foreground mt-0.5">{description}</p>
      )}
    </div>
  )

  if (actionSlot) {
    return (
      <div className={cn("mb-4 flex items-start justify-between gap-4", className)}>
        {body}
        <div className="shrink-0">{actionSlot}</div>
      </div>
    )
  }

  return <div className={cn("mb-4", className)}>{body}</div>
}
